// extracted by mini-css-extract-plugin
module.exports = {"dottedArrowIcon":"DottedArrowIcon_dottedArrowIcon__3aR97","dot":"DottedArrowIcon_dot__Ui08g","right":"DottedArrowIcon_right__3Vtlf"};